/** @format **/
// import Cookies from 'js-cookie';
import configureStore from "../../store/Store"
import { clearAuth } from "../../actions/auth"

export const preventBehavior = (e: any) =>  {
	e.preventDefault();
}

export const onTabClose = (e: any) =>  {

	// Cookies.remove('sessionId');

	// call configureStore() function to get the store instance
	const store = configureStore();

	if (store) {
		store.dispatch(clearAuth())
	}

	e.preventDefault();
	e.returnValue = '';
	delete e['returnValue'];
	
}
